import { NotificationPayloadT } from 'lib-shared-legacy-types';

/** The error notification each field component should show when save fails. */
export const errorNotification: NotificationPayloadT = {
  title: 'Failed to update attribute(s)',
  text: 'An error occurred while updating the attribute value(s)',
  time: 5000,
  type: 'error',
  icon: 'exclamation',
  status: 'danger',
};

/**
 * The success notification each field component should show when save (with
 * actual changes) succeeds.
 */
export const successNotification: NotificationPayloadT = {
  title: 'Attribute(s) updated',
  text: 'Successfully updated attribute value(s)',
  time: 5000,
  type: 'success',
  icon: 'done',
  status: 'success',
};
